export * from './src/intake-forms-v1-intake-form-intake-forms.universal.js';
